export default {
    LIST_NON_SODES: "[india][non-sode] list non-sode",
    LIST_NON_SODES_SUCCESS: "[india][non-sode] list non-sode success",
    LIST_NON_SODES_FAIL: "[india][non-sode] list non-sode fail",
    CREATE_NON_SODE: "[india][non-sode] create non-sode",
    CREATE_NON_SODE_SUCCESS: "[india][non-sode] create non-sode success",
    CREATE_NON_SODE_FAIL: "[india][non-sode] create non-sode fail",
    GET_NON_SODE_BYID: "[india][non-sode] get non-sode by id",
    GET_NON_SODE_BYID_SUCCESS: "[india][non-sode] get non-sode by id success",
    GET_NON_SODE_BYID_FAIL: "[india][non-sode] get non-sode by id fail",
    UPDATE_NON_SODE: "[india][non-sode] update non-sode",
    UPDATE_NON_SODE_SUCCESS: "[india][non-sode] update non-sode success",
    UPDATE_NON_SODE_FAIL: "[india][non-sode] update non-sode fail",
    PARTIAL_UPDATE_NON_SODE: "[india][non-sode] partial update non-sode",
    PARTIAL_UPDATE_NON_SODE_SUCCESS: "[india][non-sode] partial update non-sode success",
    PARTIAL_UPDATE_NON_SODE_FAIL: "[india][non-sode] partial update non-sode fail",
    DELETE_NON_SODE_BYID: "[india][non-sode] delete non-sode by id",
    DELETE_NON_SODE_BYID_SUCCESS: "[india][non-sode] delete non-sode byid success",
    DELETE_NON_SODE_BYID_FAIL: "[india][non-sode] delete non-sode byid fail",

    //** custom
    CHANGE_NON_SODE_SELECTED: "[custom][non-sode] change non-sode selected"
};
